import { type AxiosInstance } from 'axios';

export type ChallengeMode = 'driving_range' | 'on_course';

export type ChallengeConfig = {
  id: number;
  name: string;
  display_name: string;
  game_type: string;
  mode: ChallengeMode;
  units: 'meters' | 'yards';
  description: string | null;
};

export class ChallengeConfigsApi {
  constructor(private instance: AxiosInstance) {}

  public async getChallengeConfigs(params: { mode?: ChallengeMode }) {
    return this.instance
      .get<ChallengeConfig[]>('/challenge-configs/', { params })
      .then((res) => res.data);
  }
}
